import { helpers } from 'vuelidate/lib/validators'
export const fileSize = (param) => {
  return (value) => {
    if (!helpers.req(value)) {
      return true
    }
    const sizeKb = Math.round(value.size / 1024)
    return sizeKb <= param
  }
}
